import React from "react";
import "./header.css";
import egzoLogo from "../../asset/egzoLogo.svg";

export default function Header() {
  return (
    <header className="header">
      <div className="header-logo">
        <img src={egzoLogo} alt="EGZOTech logo"></img>
      </div>
      <div className="header-title">
        <span>License Generator</span>
      </div>
    </header>
  );
}
